import { createContext, useContext } from 'react';
import { create } from 'mobx-persist';

import AuthStore from './authStore';
import ConversationStore from './conversationStore';
import MatchingStore from './matchingStore';
import NotificationStore from './notificationStore';
import SettingStore from './settingStore';
import ReservationStore from './reservationStore';
import VideoStore from './videoStore';

const namespace = '@ZEALS_DX_END_USER';

const hydrate = create({
  storage: localStorage,
  jsonify: true,
});

export class RootStore {
  authStore = new AuthStore(this);

  settingStore = new SettingStore(this);

  matchingStore = new MatchingStore(this);

  notificationStore = new NotificationStore(this);

  conversationStore = new ConversationStore(this);

  reservationStore = new ReservationStore(this);

  videoStore = new VideoStore(this);
}

const hydrateAll = async (rootStore: RootStore): Promise<void> => {
  try {
    await Promise.all([
      hydrate(`${namespace}:auth`, rootStore.authStore),
      hydrate(`${namespace}:setting`, rootStore.settingStore),
    ]);
  } catch (err) {
    console.log(err);
    // clean localStorage
    localStorage.removeItem(`${namespace}:auth`);
    localStorage.removeItem(`${namespace}:setting`);
  }
};

const rootStore = new RootStore();

const RootStoreContext = createContext<RootStore>(rootStore);

const useStores = (): RootStore => {
  return useContext(RootStoreContext);
};

export { rootStore, useStores, hydrateAll, RootStoreContext };
